export const states = {
    UnitedStates : [
        'Alabama',
        'Alaska',
        'American Samoa',
        'Arizona' ,
        'Arkansas' ,
        'California' ,
        'Colorado' ,
        'Connecticut' ,
        'Delaware' ,
        'District of Columbia' ,
        'Florida' ,
        'Georgia' ,
        'Guam',
        'Hawaii' ,
        'Idaho' ,
        'Illinois',
        'Indiana' ,
        'Iowa' ,
        'Kansas',
        'Kentucky' ,
        'Louisiana' ,
        'Maine' ,
        'Maryland' ,
        'Massachusetts' ,
        'Michigan' ,
        'Minnesota',
        'Mississippi' ,
        'Missouri' ,
        'Montana' ,
        'Nebraska' ,
        'Nevada' ,
        'New Hampshire' ,
        'New Jersey' ,
        'New Mexico',
        'New York' ,
        'North Carolina' ,
        'North Dakota' ,
        'Northern Mariana Islands',
        'Ohio' ,
        'Oklahoma' ,
        'Oregon' ,
        "Other",
        'Pennsylvania' ,
        'Puerto Rico',
        'Rhode Island' ,
        'South Carolina' ,
        'South Dakota',
       'Tennessee',
        'Texas' ,
        'Utah',
        'Vermont',
       'Virginia',
       'Virgin Islands',
        'Washington' ,
        'West Virginia' ,
        'Wisconsin (WI)',
        'Wyoming (WY)',
], 
canadianStates : [
    'Alberta',
    'British Columbia',
    'Manitoba',
    'New Brunswick',
    'Newfoundland and Labrador',
    'Northwest Territories',
    'Nova Scotia',
    'Nunavut',
    'Ontario',
    'Other',
    'Prince Edward Island',
    'Quebec',
    'Saskatchewan',
    'Yukon',
]
}